import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",style:(_vm.outerStyles)},[_c(VImg,{attrs:{"src":require('@/_static/img/background/logo1.png'),"contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }